import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "lexon",
  extensions: [".lex"],
  aliases: ["Lexon"],
  loader: () => import('./lexon.js')
});
